<template>
  <div>
    <div class="row">
      <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12 pl-0">
        <div class="d-flex align-items-center">
          <button
            @click="handleStep('BUDGET')"
            :outlined="step != 'BUDGET'"
            :class="[
              step == 'BUDGET' && 'btn-nav-menu',
              step != 'BUDGET' && 'btn-nav-menu1',
            ]"
          >
            <strong>ORÇAMENTO</strong>
          </button>
          <div
            :class="[
              step == 'BUDGET' && 'triangulo-para-direita',
              step != 'BUDGET' && 'triangulo-none',
            ]"
          ></div>
        </div>
      </div>
      <div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 col-12 pt-0 pl-0 pr-0">
        <div
          v-if="step == 'BUDGET'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <Budget />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Budget from "./Planning/Budget";

import routes from "../../routes";

export default {
  name: "Planning",
  components: {
    Budget,
  },
  data() {
    return {
      step: "BUDGET",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    handleStep(step) {
      let newMenu = {
        BUDGET: "budget",
      }[step];

      let { nav, menu } = routes.history.current.query;

      if (menu != newMenu) {
        routes.replace({ query: { nav, menu: newMenu } });
      }

      this.step = step;
    },
    retrieve() {
      const { nav, menu } = routes.history.current.query;

      if (menu) {
        let step = {
          budget: "BUDGET",
        }[menu];

        this.step = step;
      } else {
        routes.replace({ query: { nav, menu: "budget" } });
      }
    },
  },
};
</script>
